import { schema } from 'normalizr'

const emailSurveySubscription = new schema.Entity('emailSurveySubscription')

export const emailSubscription = new schema.Entity('emailSubscription', {
  email_survey_subscriptions: [emailSurveySubscription],
})

const user = new schema.Entity('user')
export const users = { results: [user] }

export const Customer = new schema.Entity('customers')
export const Customers = { results: [Customer] }

export const AnswerDetail = new schema.Entity('answer_details')

export const Answer = new schema.Entity('answers', {
  answer_detail: AnswerDetail,
})

export const AnswerSearch = { results: [Answer] }

export const Card = new schema.Entity('card', {}, { idAttribute: 'djstripe_id' })
export const Subscription = new schema.Entity('subscription', {}, { idAttribute: 'djstripe_id' })
export const UserInfo = new schema.Entity('userInfo')

export const SurveyEmailDeliverySetting = new schema.Entity(
  'surveyEmailDeliverySetting',
  {},
  { idAttribute: 'survey_url' }
)
export const Survey = new schema.Entity('surveys')

export const Connectwise = new schema.Entity('connectwise')



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/api/schema.js